import ChatbotPatientCase from './ChatbotPatientCase';

export default ChatbotPatientCase;